import { useEffect } from "react";
import { useBillingNavigation } from "./hooks/useBillingNavigation";
import { Dialog, DialogPanel } from "@headlessui/react";
import PaymentIssuesGuardModal from "v2/components/billing/shared/PaymentIssuesGuardModal";
import { useUser } from "routes/dataroutes/UserData";
import { useActiveSubscription } from "routes/data-routes/billing-data/active-subscription";
import ViewAllPlansContentV2 from "./ViewAllPlansContentV2";
import { useBillingFlow } from "./providers/BillingFlowProvider";


export default function ViewAllPlansModal() {
  const { goBack, navigate } = useBillingNavigation();
  const { flowType } = useBillingFlow();
  const user = useUser();
  const { activeSubscriptionFetcher } = useActiveSubscription();

  // Safety fallback: redirect SLG users to contact sales if they reach this modal directly.
  // If the subscription is still loading, don't redirect to contact sales.
  useEffect(() => {
    if (activeSubscriptionFetcher.state === "loading") return;
    if (flowType === 'slg') {
      navigate('contact-sales', { replace: true });
    }
  }, [flowType, activeSubscriptionFetcher.state, navigate]);

  if (activeSubscriptionFetcher.state === "loading") {
    return null;
  }

  if (flowType === 'slg') {
    return null;
  }

  // Outstanding invoices block plan changes — guard direct nav / bookmarks here so the
  // user isn't shown a plans grid they can't act on.
  if (user?.hasPaymentIssues) {
    return <PaymentIssuesGuardModal />;
  }

  return (
    <Dialog as="div" className="relative z-30" open onClose={goBack}>
      <DialogPanel className="fixed inset-0 bg-white overflow-y-auto">
        <ViewAllPlansContentV2 onClose={goBack} />
      </DialogPanel>
    </Dialog>
  );
}
